// Generated by ReScript, PLEASE EDIT WITH CARE

import * as WorkSpaceContext from "./WorkSpaceContext.bs.js";

var make = WorkSpaceContext.context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

export {
  make ,
  makeProps ,
  
}
/* make Not a pure module */
